"use client";

import { useBoundStore } from "@/lib/stores/useBoundStore";
import { useEffect } from "react";
import { getCookie } from "@/lib/helpers";

export default function GeoLocationWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const setGeoLocation = useBoundStore((state) => state.setGeoLocation);

  useEffect(() => {
    // This runs AFTER middleware has set cookies
    const country = getCookie("x-user-country") || "US";
    const geoError = getCookie("x-geo-error") === "true";

    setGeoLocation(country, geoError);
  }, [setGeoLocation]);

  return <>{children}</>;
}
